const _excluded = ["symbol"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { forwardRef, createElement } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
const AccessDeniedIcon = forwardRef(function AccessDeniedIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "access-denied",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M18.1569 6.84315C21.281 9.96734 21.281 15.0327 18.1569 18.1569C15.0327 21.281 9.96734 21.281 6.84314 18.1569C3.71895 15.0327 3.71895 9.96734 6.84314 6.84315C9.96734 3.71895 15.0327 3.71895 18.1569 6.84315ZM18.1569 6.84315L6.84401 18.156",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ActivityIcon = forwardRef(function ActivityIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "activity",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M21 15H19L15.5 7L11 18L8 12L6 15H4",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const AddCircleIcon = forwardRef(function AddCircleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "add-circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 12.4H17M12.5 8V17M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const AddIcon = forwardRef(function AddIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "add",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 5V20M5 12.5H20",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ApiIcon = forwardRef(function ApiIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "api",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M5.93047 13.2107L6.66782 10.3728H6.73089L7.45854 13.2107H5.93047ZM8.17164 16H9.66089L7.56041 9H5.93047L3.82999 16H5.20767L5.65396 14.2876H7.73505L8.17164 16Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M10.5389 9V16H11.9166V13.7782H13.0323C14.541 13.7782 15.5015 12.8517 15.5015 11.3964C15.5015 9.92654 14.5701 9 13.1003 9H10.5389ZM11.9166 10.1303H12.751C13.6533 10.1303 14.1044 10.5475 14.1044 11.3867C14.1044 12.2308 13.6533 12.6431 12.751 12.6431H11.9166V10.1303Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M21.1675 16V14.8164H19.717V10.1836H21.1675V9H16.8889V10.1836H18.3393V14.8164H16.8889V16H21.1675Z",
      fill: "currentColor"
    })]
  }));
});
const ArchiveIcon = forwardRef(function ArchiveIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "archive",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M16 14L12.5 17.5L9 14M4.5 7.5V20.5H20.5V7.5L18.5 4.5H6.5L4.5 7.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M12.5 10.5V17",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M4.5 7.5H20.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const ArrowDownIcon = forwardRef(function ArrowDownIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "arrow-down",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 18.5V6M12.5 18.5L18 13M12.5 18.5L7 13",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ArrowLeftIcon = forwardRef(function ArrowLeftIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "arrow-left",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12 18L6.5 12.5L12 7M6.5 12.5H19",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ArrowRightIcon = forwardRef(function ArrowRightIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "arrow-right",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M13 7L18.5 12.5L13 18M18.5 12.5H6",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ArrowTopRightIcon = forwardRef(function ArrowTopRightIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "arrow-top-right",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M9 8.5H16.5V16",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16.5 8.5L7 18",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const ArrowUpIcon = forwardRef(function ArrowUpIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "arrow-up",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 6V18.5M7 11.5L12.5 6L18 11.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BarChartIcon = forwardRef(function BarChartIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bar-chart",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 5V19.5H20M8.5 18V13M11.5 18V9M14.5 18V11M17.5 18V7",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BasketIcon = forwardRef(function BasketIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "basket",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M8.5 10.5H5L6.5 19.5H18.5L20 10.5H16.5M8.5 10.5L10.2721 5.18377C10.4082 4.77543 10.7903 4.5 11.2208 4.5H13.7792C14.2097 4.5 14.5918 4.77543 14.7279 5.18377L16.5 10.5M8.5 10.5H16.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M12.5 10.5V19.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M9.5 19.5L8.5 10.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M15.5 19.5L16.5 10.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M19.5 13.5H5.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M19 16.5H6",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const BellIcon = forwardRef(function BellIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bell",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.5 17.5V18.5C10.5 20 11.5 20.5 12.5 20.5C13.5 20.5 14.5 20 14.5 18.5V17.5M5.5 17C6.5 15.5 6.5 15 6.5 12C6.5 8 8.5 5.5 12.5 5.5C16.5 5.5 18.5 8 18.5 12C18.5 15 18.5 15.5 19.5 17V17.5H5.5V17Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BillIcon = forwardRef(function BillIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bill",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M6.50001 5.5C8.50003 5.5 8.50003 8 8.50003 8V9.5M6.50001 5.5C4.5 5.5 4.5 8 4.5 8L4.50001 9.5H8.50003M6.50001 5.5C6.50001 5.5 15.8333 5.5 17.6667 5.5C19.5 5.5 19.5 8.5 19.5 8.5V20L17.6667 19L15.8333 20L14 19L12.1667 20L10.3334 19L8.50003 20V9.5M11 12.5H15M11 9.5H16M11 15.5H16",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BinaryDocumentIcon = forwardRef(function BinaryDocumentIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "binary-document",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M9.5 11.5V16.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5ZM12.5 11.5V16.5H15.5V11.5H12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "square"
    }), /* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const BlockElementIcon = forwardRef(function BlockElementIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "block-element",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M6.5 8.5V7.9H5.9V8.5H6.5ZM18.5 8.5H19.1V7.9H18.5V8.5ZM6.5 16.5H5.9V17.1H6.5V16.5ZM18.5 16.5V17.1H19.1V16.5H18.5ZM6.5 9.1H18.5V7.9H6.5V9.1ZM7.1 16.5V8.5H5.9V16.5H7.1ZM18.5 15.9H6.5V17.1H18.5V15.9ZM17.9 8.5V16.5H19.1V8.5H17.9ZM5 20.1H20V18.9H5V20.1ZM5 6.1H20V4.9H5V6.1Z",
      fill: "currentColor"
    })
  }));
});
const BlockquoteIcon = forwardRef(function BlockquoteIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "blockquote",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10 17.5H19M6 7.5H19M10 12.5H17M6.5 12V18",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BoldIcon = forwardRef(function BoldIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bold",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M13.2087 18C15.5322 18 16.9731 16.793 16.9731 14.8844C16.9731 13.4812 15.9245 12.3949 14.4836 12.2892V12.1534C15.6001 11.9875 16.4526 10.9841 16.4526 9.82991C16.4526 8.14761 15.1927 7.11409 13.0804 7.11409H8.32019V18H13.2087ZM10.5985 8.85674H12.4995C13.5859 8.85674 14.212 9.37727 14.212 10.2448C14.212 11.1199 13.5406 11.6254 12.3109 11.6254H10.5985V8.85674ZM10.5985 16.2574V13.1643H12.575C13.9178 13.1643 14.6496 13.6924 14.6496 14.6882C14.6496 15.7066 13.9404 16.2574 12.6278 16.2574H10.5985Z",
      fill: "currentColor"
    })
  }));
});
const BookIcon = forwardRef(function BookIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "book",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 18.5L4.5 19.5V18.5M12.5 18.5L20.5 19.5V18.5M12.5 18.5V6.5M12.5 18.5H4.5M12.5 18.5H20.5M4.5 18.5V17.5M20.5 18.5V17.5M4.5 5.5V17.5L12.5 18.5L20.5 17.5V5.5L12.5 6.5L4.5 5.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BottleIcon = forwardRef(function BottleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bottle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M7.5 17.5L17.5 17.5M17.5 13C17.5 12.087 17.5 11.3518 17.5 11C17.5 8.5 14.5 9 14.5 7.37494L14.5 5.5M17.5 13C17.5 15.1229 17.5 18.7543 17.5 20.5022C17.5 21.0545 17.0523 21.5 16.5 21.5L8.5 21.5C7.94771 21.5 7.5 21.0547 7.5 20.5024C7.5 18.8157 7.5 15.3546 7.5 13M17.5 13L7.5 13M7.5 13C7.5 12.2538 7.5 11.5648 7.5 11C7.5 8.5 10.5 9 10.5 7.37494L10.5 5.5M10.5 5.5L10.5 3.99999C10.5 3.72385 10.7239 3.49999 11 3.49999L14 3.49999C14.2761 3.49999 14.5 3.72385 14.5 3.99999L14.5 5.5M10.5 5.5L14.5 5.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const BulbFilledIcon = forwardRef(function BulbFilledIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bulb-filled",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.4272 14.3368C15.8273 15.1773 15.5 16.1794 15.5 17.212V18.5C15.5 19.0523 15.0523 19.5 14.5 19.5H14V20.5C14 21.0523 13.5523 21.5 13 21.5H12C11.4477 21.5 11 21.0523 11 20.5V19.5H10.5C9.94772 19.5 9.5 19.0523 9.5 18.5V17.212C9.5 16.1794 9.17266 15.1773 8.57284 14.3368C7.60216 12.9767 7 11.94 7 10C7 7 9.5 4.5 12.5 4.5C15.5 4.5 18 7 18 10C18 11.94 17.3978 12.9767 16.4272 14.3368Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M16.4272 14.3368L15.9388 13.9883L16.4272 14.3368ZM14 19.5V18.9H13.4V19.5H14ZM11 19.5H11.6V18.9H11V19.5ZM8.57284 14.3368L9.06122 13.9883H9.06122L8.57284 14.3368ZM16.1 17.212C16.1 16.3069 16.3868 15.4261 16.9155 14.6853L15.9388 13.9883C15.2678 14.9284 14.9 16.0519 14.9 17.212H16.1ZM16.1 18.5V17.212H14.9V18.5H16.1ZM14.5 20.1C15.3837 20.1 16.1 19.3837 16.1 18.5H14.9C14.9 18.7209 14.7209 18.9 14.5 18.9V20.1ZM14 20.1H14.5V18.9H14V20.1ZM13.4 19.5V20.5H14.6V19.5H13.4ZM13.4 20.5C13.4 20.7209 13.2209 20.9 13 20.9V22.1C13.8837 22.1 14.6 21.3837 14.6 20.5H13.4ZM13 20.9H12V22.1H13V20.9ZM12 20.9C11.7791 20.9 11.6 20.7209 11.6 20.5H10.4C10.4 21.3837 11.1163 22.1 12 22.1V20.9ZM11.6 20.5V19.5H10.4V20.5H11.6ZM10.5 20.1H11V18.9H10.5V20.1ZM8.9 18.5C8.9 19.3837 9.61634 20.1 10.5 20.1V18.9C10.2791 18.9 10.1 18.7209 10.1 18.5H8.9ZM8.9 17.212V18.5H10.1V17.212H8.9ZM8.08446 14.6853C8.61315 15.4261 8.9 16.3069 8.9 17.212H10.1C10.1 16.0519 9.73217 14.9284 9.06122 13.9883L8.08446 14.6853ZM6.4 10C6.4 11.0377 6.56208 11.8595 6.86624 12.611C7.16624 13.3521 7.59495 13.9995 8.08446 14.6853L9.06122 13.9883C8.58004 13.314 8.22233 12.7629 7.97858 12.1607C7.739 11.5688 7.6 10.9023 7.6 10H6.4ZM12.5 3.9C9.16863 3.9 6.4 6.66863 6.4 10H7.6C7.6 7.33137 9.83137 5.1 12.5 5.1V3.9ZM18.6 10C18.6 6.66863 15.8314 3.9 12.5 3.9V5.1C15.1686 5.1 17.4 7.33137 17.4 10H18.6ZM16.9155 14.6853C17.4051 13.9995 17.8338 13.3521 18.1338 12.611C18.4379 11.8595 18.6 11.0377 18.6 10H17.4C17.4 10.9023 17.261 11.5688 17.0214 12.1607C16.7777 12.7629 16.42 13.314 15.9388 13.9883L16.9155 14.6853Z",
      fill: "currentColor"
    })]
  }));
});
const BulbOutlineIcon = forwardRef(function BulbOutlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "bulb-outline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9.5 16.5H15.5M11 20V20.5C11 21.0523 11.4477 21.5 12 21.5H13C13.5523 21.5 14 21.0523 14 20.5V20M18 10C18 11.94 17.3978 12.9767 16.4272 14.3368C15.8273 15.1773 15.5 16.1794 15.5 17.212V18.5C15.5 19.0523 15.0523 19.5 14.5 19.5H10.5C9.94772 19.5 9.5 19.0523 9.5 18.5V17.212C9.5 16.1794 9.17266 15.1773 8.57284 14.3368C7.60216 12.9767 7 11.94 7 10C7 7 9.5 4.5 12.5 4.5C15.5 4.5 18 7 18 10Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CalendarIcon = forwardRef(function CalendarIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "calendar",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M4.5 10.5V19.5H20.5V10.5M4.5 10.5V5.5H20.5V10.5M4.5 10.5H12.5H20.5M20.5 13.5H16.5M16.5 13.5H12.5M16.5 13.5V10.5M16.5 13.5V16.5M12.5 13.5H8.5M12.5 13.5V16.5M12.5 13.5V10.5M8.5 13.5H4.5M8.5 13.5V10.5M8.5 13.5V16.5M20.5 16.5H16.5M16.5 16.5H12.5M16.5 16.5V19.5M12.5 16.5H8.5M12.5 16.5V19.5M8.5 16.5H4.5M8.5 16.5V19.5M17.5 8V3M7.5 8V3",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CaseIcon = forwardRef(function CaseIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "case",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9 8.5122V6C9 5.44772 9.44772 5 10 5H15C15.5523 5 16 5.44772 16 6V8.5122M4.5 12V18.5C4.5 19.0523 4.94772 19.5 5.5 19.5H19.5C20.0523 19.5 20.5 19.0523 20.5 18.5V12M4.5 12V9.5122C4.5 8.95991 4.94772 8.5122 5.5 8.5122H19.5C20.0523 8.5122 20.5 8.95991 20.5 9.5122V12M4.5 12L11.7978 14.7367C12.2505 14.9064 12.7495 14.9064 13.2022 14.7367L20.5 12",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ChartUpwardIcon = forwardRef(function ChartUpwardIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "chart-upward",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 5V19.5H20M7.5 16L11.5 11.5L15.5 14L19.5 8.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CheckmarkCircleIcon = forwardRef(function CheckmarkCircleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "checkmark-circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9.5 12.1316L11.7414 14.5L16 10M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CheckmarkIcon = forwardRef(function CheckmarkIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "checkmark",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 11.5L10.5 16.5L19.5 7.60001",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ChevronDownIcon = forwardRef(function ChevronDownIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "chevron-down",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17 10.5L12.5 15L8 10.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ChevronLeftIcon = forwardRef(function ChevronLeftIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "chevron-left",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M14.5 17L10 12.5L14.5 8",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ChevronRightIcon = forwardRef(function ChevronRightIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "chevron-right",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.5 8L15 12.5L10.5 17",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ChevronUpIcon = forwardRef(function ChevronUpIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "chevron-up",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 14.5L12.5 10L17 14.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CircleIcon = forwardRef(function CircleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("circle", {
      cx: 12.5,
      cy: 12.5,
      r: 8,
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ClipboardIcon = forwardRef(function ClipboardIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "clipboard",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 5.5H6.5V19.5H18.5V5.5H17M12.5 3C11.5 3 11.5 4.5 11 4.5C10 4.5 9.5 5 9.5 6.5H15.6C15.6 5 15 4.5 14 4.5C13.5 4.5 13.5 3 12.5 3Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ClipboardImageIcon = forwardRef(function ClipboardImageIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "clipboard-image",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 5.5H6.5V19.5H10.5M17 5.5H18.5V11.5M10.5 18.5L12.73 15.8983C13.1327 15.4285 13.8613 15.4335 14.2575 15.909L15.299 17.1588C15.6754 17.6105 16.3585 17.6415 16.7743 17.2257L16.9903 17.0097C17.2947 16.7053 17.7597 16.6298 18.1447 16.8223L20.5 18M10.5 11.5H20.5V21.5H10.5V11.5ZM12.5 3C11.5 3 11.5 4.5 11 4.5C10 4.5 9.5 5 9.5 6.5H15.6C15.6 5 15 4.5 14 4.5C13.5 4.5 13.5 3 12.5 3Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ClockIcon = forwardRef(function ClockIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "clock",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 8V12.5L15.5 15.5M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CloseCircleIcon = forwardRef(function CloseCircleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "close-circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9.5 15.5L12.5 12.5M12.5 12.5L15.5 9.5M12.5 12.5L9.5 9.5M12.5 12.5L15.5 15.5M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CloseIcon = forwardRef(function CloseIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "close",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M18 7L7 18M7 7L18 18",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CodeBlockIcon = forwardRef(function CodeBlockIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "code-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M11 15L8.5 12.5L11 10M14 10L16.5 12.5L14 15M5.5 6.5H19.5V18.5H5.5V6.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CodeIcon = forwardRef(function CodeIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "code",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M7.5 12.5L7.07574 12.0757L6.65147 12.5L7.07574 12.9243L7.5 12.5ZM17.5 12.5L17.9243 12.9243L18.3485 12.5L17.9243 12.0757L17.5 12.5ZM11.4243 15.5757L7.92426 12.0757L7.07574 12.9243L10.5757 16.4243L11.4243 15.5757ZM7.92426 12.9243L11.4243 9.42426L10.5757 8.57574L7.07574 12.0757L7.92426 12.9243ZM13.5757 9.42426L17.0757 12.9243L17.9243 12.0757L14.4243 8.57574L13.5757 9.42426ZM17.0757 12.0757L13.5757 15.5757L14.4243 16.4243L17.9243 12.9243L17.0757 12.0757Z",
      fill: "currentColor"
    })
  }));
});
const CogIcon = forwardRef(function CogIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "cog",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M14.2624 5.40607L13.8714 4.42848C13.6471 3.86771 13.104 3.5 12.5 3.5C11.896 3.5 11.3529 3.86771 11.1286 4.42848L10.7376 5.40607C10.5857 5.78585 10.2869 6.08826 9.90901 6.2448C9.53111 6.40133 9.10603 6.39874 8.73006 6.23761L7.76229 5.82285C7.20716 5.58494 6.56311 5.70897 6.13604 6.13604C5.70897 6.56311 5.58494 7.20716 5.82285 7.76229L6.23761 8.73006C6.39874 9.10602 6.40133 9.53111 6.2448 9.90901C6.08826 10.2869 5.78585 10.5857 5.40607 10.7376L4.42848 11.1286C3.86771 11.3529 3.5 11.896 3.5 12.5C3.5 13.104 3.86771 13.6471 4.42848 13.8714L5.40607 14.2624C5.78585 14.4143 6.08826 14.7131 6.2448 15.091C6.40133 15.4689 6.39874 15.894 6.23761 16.2699L5.82285 17.2377C5.58494 17.7928 5.70897 18.4369 6.13604 18.864C6.56311 19.291 7.20716 19.4151 7.76229 19.1772L8.73006 18.7624C9.10603 18.6013 9.53111 18.5987 9.90901 18.7552C10.2869 18.9117 10.5857 19.2141 10.7376 19.5939L11.1286 20.5715C11.3529 21.1323 11.896 21.5 12.5 21.5C13.104 21.5 13.6471 21.1323 13.8714 20.5715L14.2624 19.5939C14.4143 19.2141 14.7131 18.9117 15.091 18.7552C15.4689 18.5987 15.894 18.6013 16.2699 18.7624L17.2377 19.1771C17.7928 19.4151 18.4369 19.291 18.864 18.864C19.291 18.4369 19.4151 17.7928 19.1771 17.2377L18.7624 16.2699C18.6013 15.894 18.5987 15.4689 18.7552 15.091C18.9117 14.7131 19.2141 14.4143 19.5939 14.2624L20.5715 13.8714C21.1323 13.6471 21.5 13.104 21.5 12.5C21.5 11.896 21.1323 11.3529 20.5715 11.1286L19.5939 10.7376C19.2141 10.5857 18.9117 10.2869 18.7552 9.90901C18.5987 9.53111 18.6013 9.10602 18.7624 8.73006L19.1772 7.76229C19.4151 7.20716 19.291 6.56311 18.864 6.13604C18.4369 5.70897 17.7928 5.58494 17.2377 5.82285L16.2699 6.23761C15.894 6.39874 15.4689 6.40133 15.091 6.2448C14.7131 6.08826 14.4143 5.78585 14.2624 5.40607Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16.5 12.5C16.5 14.7091 14.7091 16.5 12.5 16.5C10.2909 16.5 8.5 14.7091 8.5 12.5C8.5 10.2909 10.2909 8.5 12.5 8.5C14.7091 8.5 16.5 10.2909 16.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const CollapseIcon = forwardRef(function CollapseIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "collapse",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M6 14.5L10.5 14.5V19M19 10.5H14.5L14.5 6",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M10.5 14.5L6 19",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M14.5 10.5L19 6",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const CommentIcon = forwardRef(function CommentIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "comment",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M7.5 16.5H9.5V20.5L13.5 16.5H17.5C18.6046 16.5 19.5 15.6046 19.5 14.5V8.5C19.5 7.39543 18.6046 6.5 17.5 6.5H7.5C6.39543 6.5 5.5 7.39543 5.5 8.5V14.5C5.5 15.6046 6.39543 16.5 7.5 16.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ComponentIcon = forwardRef(function ComponentIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "component",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8.5 8.5L12.5 12.5M12.5 12.5L16.5 16.5M12.5 12.5L16.5 8.5M12.5 12.5L8.5 16.5M12.5 4L21 12.5L12.5 21L4 12.5L12.5 4Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ComposeIcon = forwardRef(function ComposeIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "compose",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17 6L19 8M14 5.5H5.5V19.5H19.5V11M9 16L9.5 13.5L19 4L21 6L11.5 15.5L9 16Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ControlsIcon = forwardRef(function ControlsIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "controls",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M6.5 5V7.5M6.5 7.5C5.39543 7.5 4.5 8.39543 4.5 9.5C4.5 10.6046 5.39543 11.5 6.5 11.5M6.5 7.5C7.60457 7.5 8.5 8.39543 8.5 9.5C8.5 10.6046 7.60457 11.5 6.5 11.5M6.5 11.5V20M12.5 5V13.5M12.5 13.5C11.3954 13.5 10.5 14.3954 10.5 15.5C10.5 16.6046 11.3954 17.5 12.5 17.5M12.5 13.5C13.6046 13.5 14.5 14.3954 14.5 15.5C14.5 16.6046 13.6046 17.5 12.5 17.5M12.5 17.5V20M18.5 5V7.5M18.5 7.5C17.3954 7.5 16.5 8.39543 16.5 9.5C16.5 10.6046 17.3954 11.5 18.5 11.5M18.5 7.5C19.6046 7.5 20.5 8.39543 20.5 9.5C20.5 10.6046 19.6046 11.5 18.5 11.5M18.5 11.5V20",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CopyIcon = forwardRef(function CopyIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "copy",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8.5 8.5H5.5V20.5H16.5V16.5M19.5 4.5H8.5V16.5H19.5V4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CreditCardIcon = forwardRef(function CreditCardIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "credit-card",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M4.5 10.5H20.5M4.5 9.5H20.5M4.5 11.5H20.5M7 15.5H14M5.5 18.5H19.5C20.0523 18.5 20.5 18.0523 20.5 17.5V7.5C20.5 6.94772 20.0523 6.5 19.5 6.5H5.5C4.94772 6.5 4.5 6.94772 4.5 7.5V17.5C4.5 18.0523 4.94772 18.5 5.5 18.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const CropIcon = forwardRef(function CropIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "crop",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8.5 4V16.5H21M4 8.5H16.5V21",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DashboardIcon = forwardRef(function DashboardIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "dashboard",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M14.5 19.5V12.5M10.5 12.5V5.5M5.5 12.5H19.5M5.5 19.5H19.5V5.5H5.5V19.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DatabaseIcon = forwardRef(function DatabaseIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "database",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M18.5 7V17.5C18.5 19.0594 16.0504 20.5 12.5 20.5C8.9496 20.5 6.5 19.0594 6.5 17.5V7M18.5 7C18.5 8.45543 15.8137 9.5 12.5 9.5C9.18629 9.5 6.5 8.45543 6.5 7C6.5 5.54457 9.18629 4.5 12.5 4.5C15.8137 4.5 18.5 5.54457 18.5 7Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DesktopIcon = forwardRef(function DesktopIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "desktop",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M4.5 14.5V16.5C4.5 17.0523 4.94772 17.5 5.5 17.5H12.5M4.5 14.5V6.5C4.5 5.94772 4.94772 5.5 5.5 5.5H19.5C20.0523 5.5 20.5 5.94772 20.5 6.5V14.5M4.5 14.5H20.5M20.5 14.5V16.5C20.5 17.0523 20.0523 17.5 19.5 17.5H12.5M12.5 17.5V20.5M12.5 20.5H8M12.5 20.5H17",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DocumentIcon = forwardRef(function DocumentIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DocumentPdfIcon = forwardRef(function DocumentPdfIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-pdf",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M12.7414 13.14L12.749 13.1046C12.896 12.4991 13.0809 11.7442 12.9365 11.0602C12.8402 10.5206 12.4425 10.3104 12.1031 10.2952C11.7028 10.2775 11.3456 10.5054 11.2569 10.8373C11.0897 11.4453 11.2392 12.2762 11.5128 13.3351C11.1683 14.1559 10.6186 15.3491 10.2158 16.0584C9.46592 16.446 8.46022 17.0438 8.31075 17.7987C8.28036 17.9381 8.31582 18.1154 8.39942 18.275C8.49315 18.4523 8.64261 18.5891 8.81741 18.655C8.89341 18.6828 8.9846 18.7056 9.091 18.7056C9.53686 18.7056 10.2588 18.3459 11.2215 16.6942C11.3684 16.6461 11.5204 16.5954 11.6673 16.5448C12.3564 16.3117 13.0708 16.0685 13.7167 15.9596C14.4311 16.3421 15.2443 16.5878 15.7966 16.5878C16.3437 16.5878 16.5591 16.2636 16.6401 16.0685C16.782 15.7265 16.7136 15.2959 16.4831 15.0653C16.1487 14.736 15.3355 14.6499 14.0689 14.8069C13.4457 14.4269 13.0378 13.9102 12.7414 13.14ZM9.96245 16.9881C9.61032 17.4998 9.34433 17.7557 9.19993 17.8671C9.36966 17.5555 9.70152 17.2262 9.96245 16.9881ZM12.1816 11.0222C12.3133 11.2477 12.2956 11.9291 12.1943 12.2737C12.0701 11.7695 12.0524 11.0552 12.1259 10.9716L12.1816 11.0222ZM12.1411 14.0748C12.4121 14.5435 12.7541 14.9463 13.1316 15.2452C12.5844 15.3693 12.0853 15.5745 11.6395 15.7569C11.5331 15.8 11.4292 15.843 11.3279 15.8836C11.6648 15.2731 11.946 14.5815 12.1411 14.0748ZM16.0828 15.7341L16.0676 15.7569C16.0676 15.7569 15.8346 15.8988 14.9403 15.5466C15.9688 15.4985 16.0828 15.7341 16.0828 15.7341Z",
      fill: "currentColor"
    })]
  }));
});
const DocumentRemoveIcon = forwardRef(function DocumentRemoveIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-remove",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2515 3.9H10.5H18.5H19.1V4.5V11.9H17.9V5.1H11.1V8.5V9.1H10.5H7.09999V11.9H5.89999V8.5V8.25147L6.07573 8.07574L10.0757 4.07574L10.2515 3.9ZM17.9 19.9V14.1H19.1V20.5V21.1H18.5H6.49999H5.89999V20.5V14.1H7.09999V19.9H17.9ZM7.94852 7.9H9.89999V5.94853L7.94852 7.9ZM2 13.6H23V12.4H2V13.6Z",
      fill: "currentColor"
    })
  }));
});
const DocumentSheetIcon = forwardRef(function DocumentSheetIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-sheet",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("line", {
      x1: 10.4,
      y1: 19,
      x2: 10.4,
      y2: 10,
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("line", {
      x1: 14.4,
      y1: 19,
      x2: 14.4,
      y2: 10,
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("line", {
      x1: 8,
      y1: 12.4,
      x2: 17,
      y2: 12.4,
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("line", {
      x1: 8,
      y1: 16.4,
      x2: 17,
      y2: 16.4,
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const DocumentTextIcon = forwardRef(function DocumentTextIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-text",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16 12H12.5H9",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M14 15H12.5H9",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const DocumentVideoIcon = forwardRef(function DocumentVideoIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-video",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M11.5 15.5V12.5L14 14L11.5 15.5Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const DocumentWordIcon = forwardRef(function DocumentWordIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-word",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M12.4699 13.4588H12.5263L13.6328 17H14.5435L16 12H14.9952L14.0656 15.7214H14.0129L12.929 12H12.0672L10.9984 15.7214H10.9419L10.0124 12H9L10.4565 17H11.371L12.4699 13.4588Z",
      fill: "currentColor"
    })]
  }));
});
const DocumentZipIcon = forwardRef(function DocumentZipIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "document-zip",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M10.5 4.5V8.5H6.5M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M15 4.5L13.5 5L15.5 6L13.5 7L15.5 8L13.5 9L15.5 10L13.5 11L14.5 11.5V13",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }), /* @__PURE__ */jsx("path", {
      d: "M13.5 13H15.5L16 17H13L13.5 13Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const DocumentsIcon = forwardRef(function DocumentsIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "documents",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M16.5 6.5H19.5V21.5H8.5V18.5M10 3.5V8H5.5M10 3.5H16.5V18.5H5.5V8L10 3.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DotIcon = forwardRef(function DotIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "dot",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("circle", {
      cx: 12.5,
      cy: 12.5,
      r: 1.5,
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DoubleChevronDownIcon = forwardRef(function DoubleChevronDownIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "double-chevron-down",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17 8.5L12.5 13L8 8.5M17 12.5L12.5 17L8 12.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DoubleChevronLeftIcon = forwardRef(function DoubleChevronLeftIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "double-chevron-left",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 17L8 12.5L12.5 8M16.5 17L12 12.5L16.5 8",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DoubleChevronRightIcon = forwardRef(function DoubleChevronRightIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "double-chevron-right",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 8L17 12.5L12.5 17M8.5 8L13 12.5L8.5 17",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DoubleChevronUpIcon = forwardRef(function DoubleChevronUpIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "double-chevron-up",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 12.5L12.5 8L17 12.5M8 16.5L12.5 12L17 16.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DownloadIcon = forwardRef(function DownloadIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "download",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M19.5 17V19.5H5.5V17M17.5 11L12.5 16L7.5 11M12.5 16V4.99998",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const DragHandleIcon = forwardRef(function DragHandleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "drag-handle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14ZM11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5ZM15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z",
      fill: "currentColor"
    })
  }));
});
const DropIcon = forwardRef(function DropIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "drop",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M18.5 14.5C18.5 18 16 20.5 12.5 20.5C9 20.5 6.5 18 6.5 14.5C6.5 11 9.5 7.50001 12.5 4.5C15.5 7.5 18.5 11 18.5 14.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const EarthAmericasIcon = forwardRef(function EarthAmericasIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "earth-americas",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.9 19.4303V16.7515L11.5203 15.1312L8.60296 13.4642L7.6 12.2105V13L6.4382 13.2107L5.3943 10.4269C5.20272 11.0847 5.1 11.7804 5.1 12.5C5.1 15.672 7.09572 18.3778 9.9 19.4303ZM15.6 5.77866V11.4485L13.7515 9.6H11.3L10.2922 10.9437L10.7485 11.4H12.6V12.8183L13.3211 13.9H15.7172L18.7651 16.4399C19.484 15.2991 19.9 13.9481 19.9 12.5C19.9 9.52001 18.1385 6.95143 15.6 5.77866ZM15.6 4.47567C18.8178 5.71962 21.1 8.84329 21.1 12.5C21.1 17.2497 17.2496 21.1 12.5 21.1C7.75035 21.1 3.9 17.2497 3.9 12.5C3.9 7.75035 7.75035 3.9 12.5 3.9C13.5164 3.9 14.4915 4.07631 15.3966 4.4H15.6V4.47567Z",
      fill: "currentColor"
    })
  }));
});
const EarthGlobeIcon = forwardRef(function EarthGlobeIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "earth-globe",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 16.5H19.5M5.5 8.5H19.5M4.5 12.5H20.5M12.5 20.5C12.5 20.5 8 18.5 8 12.5C8 6.5 12.5 4.5 12.5 4.5M12.5 4.5C12.5 4.5 17 6.5 17 12.5C17 18.5 12.5 20.5 12.5 20.5M12.5 4.5V20.5M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const EditIcon = forwardRef(function EditIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "edit",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M15 7L18 10M6 19L7 15L17 5L20 8L10 18L6 19Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const EllipsisHorizontalIcon = forwardRef(function EllipsisHorizontalIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "ellipsis-horizontal",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M6.5 11C7.32843 11 8 11.6716 8 12.5C8 13.3284 7.32843 14 6.5 14C5.67157 14 5 13.3284 5 12.5C5 11.6716 5.67157 11 6.5 11Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M12.5 11C13.3284 11 14 11.6716 14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5C11 11.6716 11.6716 11 12.5 11Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M18.5 11C19.3284 11 20 11.6716 20 12.5C20 13.3284 19.3284 14 18.5 14C17.6716 14 17 13.3284 17 12.5C17 11.6716 17.6716 11 18.5 11Z",
      fill: "currentColor"
    })]
  }));
});
const EllipsisVerticalIcon = forwardRef(function EllipsisVerticalIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "ellipsis-vertical",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 6.5C14 7.32843 13.3284 8 12.5 8C11.6716 8 11 7.32843 11 6.5C11 5.67157 11.6716 5 12.5 5C13.3284 5 14 5.67157 14 6.5ZM14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5C11 11.6716 11.6716 11 12.5 11C13.3284 11 14 11.6716 14 12.5ZM12.5 20C13.3284 20 14 19.3284 14 18.5C14 17.6716 13.3284 17 12.5 17C11.6716 17 11 17.6716 11 18.5C11 19.3284 11.6716 20 12.5 20Z",
      fill: "currentColor"
    })
  }));
});
const EnvelopeIcon = forwardRef(function EnvelopeIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "envelope",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M20.5 18.5H4.5V6.5H20.5V18.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M20.5 18.5L17.75 15.5L15 12.5M4.5 18.5L10 12.5M20.5 6.5L12.5 15L4.5 6.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const EqualIcon = forwardRef(function EqualIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "equal",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M7.5 4.5H3.5V20.5H7.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M17.5 20.5L21.5 20.5L21.5 4.5L17.5 4.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M9 10.5H16",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M9 14.5H16",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const ErrorFilledIcon = forwardRef(function ErrorFilledIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "error-filled",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12.5C4 7.80558 7.80558 4 12.5 4C17.1944 4 21 7.80558 21 12.5C21 17.1944 17.1944 21 12.5 21C7.80558 21 4 17.1944 4 12.5ZM13 14.5V16H12V14.5H13ZM12 9V13H13V9H12Z",
      fill: "currentColor"
    })
  }));
});
const ErrorOutlineIcon = forwardRef(function ErrorOutlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "error-outline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 16V14.5M12.5 9V13M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ExpandIcon = forwardRef(function ExpandIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "expand",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M14 6.5H18.5V11M11 18.5H6.5V14",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M18.5 6.5L14 11M6.5 18.5L11 14",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const EyeClosedIcon = forwardRef(function EyeClosedIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "eye-closed",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M7 15.5L5.5 17.5M20.5 12.5C19.8612 13.5647 19.041 14.6294 18.0008 15.501M18.0008 15.501C16.5985 16.676 14.7965 17.5 12.5 17.5M18.0008 15.501L18 15.5M18.0008 15.501L19.5 17.5M12.5 17.5C8.5 17.5 6 15 4.5 12.5M12.5 17.5V20M15.5 17L16.5 19.5M9.5 17L8.5 19.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const EyeOpenIcon = forwardRef(function EyeOpenIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "eye-open",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.20513 12.5C6.66296 14.7936 8.9567 16.9 12.5 16.9C16.0433 16.9 18.3371 14.7936 19.7949 12.5C18.3371 10.2064 16.0433 8.1 12.5 8.1C8.9567 8.1 6.66296 10.2064 5.20513 12.5ZM3.98551 12.1913C5.53974 9.60093 8.20179 6.9 12.5 6.9C16.7982 6.9 19.4603 9.60093 21.0145 12.1913L21.1997 12.5L21.0145 12.8087C19.4603 15.3991 16.7982 18.1 12.5 18.1C8.20179 18.1 5.53974 15.3991 3.98551 12.8087L3.80029 12.5L3.98551 12.1913ZM12.5 9.4C10.7879 9.4 9.4 10.7879 9.4 12.5C9.4 14.2121 10.7879 15.6 12.5 15.6C14.2121 15.6 15.6 14.2121 15.6 12.5C15.6 10.7879 14.2121 9.4 12.5 9.4Z",
      fill: "currentColor"
    })
  }));
});
const FilterIcon = forwardRef(function FilterIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "filter",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M11 12L6 7V6L19 6L19 7L14 12V17L11 19V12Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "square"
    })
  }));
});
const FolderIcon = forwardRef(function FolderIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "folder",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M11.5 8.5H19.5V18.5H5.5V5.5H10.5L11.5 8.5ZM11.5 8.5H5.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const GenerateIcon = forwardRef(function GenerateIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "generate",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M9 5.30423C6.33576 6.60253 4.5 9.33688 4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5V14.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16 11L12.5 14.5L9 11",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const HeartFilledIcon = forwardRef(function HeartFilledIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "heart-filled",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17 16C15.8 17.3235 12.5 20.5 12.5 20.5C12.5 20.5 9.2 17.3235 8 16C5.2 12.9118 4.5 11.7059 4.5 9.5C4.5 7.29412 6.1 5.5 8.5 5.5C10.5 5.5 11.7 6.82353 12.5 8.14706C13.3 6.82353 14.5 5.5 16.5 5.5C18.9 5.5 20.5 7.29412 20.5 9.5C20.5 11.7059 19.8 12.9118 17 16Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const HeartIcon = forwardRef(function HeartIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "heart",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17 16C15.8 17.3235 12.5 20.5 12.5 20.5C12.5 20.5 9.2 17.3235 8 16C5.2 12.9118 4.5 11.7059 4.5 9.5C4.5 7.29412 6.1 5.5 8.5 5.5C10.5 5.5 11.7 6.82353 12.5 8.14706C13.3 6.82353 14.5 5.5 16.5 5.5C18.9 5.5 20.5 7.29412 20.5 9.5C20.5 11.7059 19.8 12.9118 17 16Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const HelpCircleIcon = forwardRef(function HelpCircleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "help-circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 13C12.5 11 14 11.5 14 10C14 9.34375 13.5 8.5 12.5 8.5C11.5 8.5 11 9 10.5 9.5M12.5 16V14.5M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const HomeIcon = forwardRef(function HomeIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "home",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M6.5 8.75V18.5H18.5V8.75M4.5 10L12.5 5L20.5 10M14.5 18.5V11.5H10.5V18.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const IceCreamIcon = forwardRef(function IceCreamIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "ice-cream",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9.5 13.5L12.5 20.5L15.5 13.5M12.5 8.26389C11.9692 7.78885 11.2684 7.5 10.5 7.5C8.84315 7.5 7.5 8.84315 7.5 10.5C7.5 12.1569 8.84315 13.5 10.5 13.5C11.2684 13.5 11.9692 13.2111 12.5 12.7361M9.5 7.5C9.5 5.84315 10.8431 4.5 12.5 4.5C14.1569 4.5 15.5 5.84315 15.5 7.5M17.5 10.5C17.5 12.1569 16.1569 13.5 14.5 13.5C12.8431 13.5 11.5 12.1569 11.5 10.5C11.5 8.84315 12.8431 7.5 14.5 7.5C16.1569 7.5 17.5 8.84315 17.5 10.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ImageIcon = forwardRef(function ImageIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "image",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 15.5L8.79289 12.2071C9.18342 11.8166 9.81658 11.8166 10.2071 12.2071L12.8867 14.8867C13.2386 15.2386 13.7957 15.2782 14.1938 14.9796L15.1192 14.2856C15.3601 14.1049 15.6696 14.0424 15.9618 14.1154L19.5 15M5.5 6.5H19.5V18.5H5.5V6.5ZM15.5 10.5C15.5 11.0523 15.0523 11.5 14.5 11.5C13.9477 11.5 13.5 11.0523 13.5 10.5C13.5 9.94772 13.9477 9.5 14.5 9.5C15.0523 9.5 15.5 9.94772 15.5 10.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ImageRemoveIcon = forwardRef(function ImageRemoveIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "image-remove",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.9 5.9H5.5H19.5H20.1V6.5V11.4H18.9V7.1H6.1V11.4H4.9V6.5V5.9ZM18.9 13.7315V13.6H20.1V18.5V19.1H19.5H5.5H4.9V18.5V13.6H7.74853L6.1 15.2485V17.9H18.9V14.9685L15.8162 14.1975C15.6994 14.1683 15.5756 14.1933 15.4792 14.2656L14.5538 14.9596C13.9168 15.4374 13.0255 15.374 12.4625 14.811L11.2515 13.6H12.9485L13.311 13.9625C13.4518 14.1032 13.6746 14.1191 13.8338 13.9996L14.3667 13.6H18.3739L18.9 13.7315ZM12.9 10C12.9 10.6024 13.2329 11.1271 13.7248 11.4H15.2752C15.7671 11.1271 16.1 10.6024 16.1 10C16.1 9.11635 15.3837 8.4 14.5 8.4C13.6163 8.4 12.9 9.11635 12.9 10ZM8.25147 11.4H10.7485L10.6314 11.2828C10.0065 10.658 8.99347 10.658 8.36863 11.2828L8.25147 11.4ZM14.1 10C14.1 9.77909 14.2791 9.6 14.5 9.6C14.7209 9.6 14.9 9.77909 14.9 10C14.9 10.2209 14.7209 10.4 14.5 10.4C14.2791 10.4 14.1 10.2209 14.1 10ZM2 13.1H23V11.9H2V13.1Z",
      fill: "currentColor"
    })
  }));
});
const ImagesIcon = forwardRef(function ImagesIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "images",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M18.5 7.5H20.5V19.5H6.5V17.5M4.5 14.5L7.79289 11.2071C8.18342 10.8166 8.81658 10.8166 9.20711 11.2071L11.8867 13.8867C12.2386 14.2386 12.7957 14.2782 13.1938 13.9796L14.1192 13.2856C14.3601 13.1049 14.6696 13.0424 14.9618 13.1154L18.5 14M4.5 5.5H18.5V17.5H4.5V5.5ZM14.5 9.5C14.5 10.0523 14.0523 10.5 13.5 10.5C12.9477 10.5 12.5 10.0523 12.5 9.5C12.5 8.94772 12.9477 8.5 13.5 8.5C14.0523 8.5 14.5 8.94772 14.5 9.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const InfoFilledIcon = forwardRef(function InfoFilledIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "info-filled",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 12.5C21 17.1944 17.1944 21 12.5 21C7.80558 21 4 17.1944 4 12.5C4 7.80558 7.80558 4 12.5 4C17.1944 4 21 7.80558 21 12.5ZM12 10.5V9H13V10.5H12ZM13 16V12H12V16H13Z",
      fill: "currentColor"
    })
  }));
});
const InfoOutlineIcon = forwardRef(function InfoOutlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "info-outline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 10.5V9M12.5 12V16M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const InlineElementIcon = forwardRef(function InlineElementIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "inline-element",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M16.5 6.5H17.1V5.9H16.5V6.5ZM8.5 6.5V5.9H7.9V6.5H8.5ZM16.5 18.5V19.1H17.1V18.5H16.5ZM8.5 18.5H7.9V19.1H8.5V18.5ZM16.5 5.9H8.5V7.1H16.5V5.9ZM17.1 18.5V6.5H15.9V18.5H17.1ZM8.5 19.1H16.5V17.9H8.5V19.1ZM7.9 6.5V18.5H9.1V6.5H7.9ZM4.9 5V20H6.1V5H4.9ZM18.9 5V20H20.1V5H18.9Z",
      fill: "currentColor"
    })
  }));
});
const InlineIcon = forwardRef(function InlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "inline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 6.5H19.5V18.5H12.5M12.5 6.5H5.5V18.5H12.5M12.5 6.5V18.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const InsertAboveIcon = forwardRef(function InsertAboveIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "insert-above",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M14.5 10.5556L10.5 10.5556M12.5 12.5L12.5 8.50001M18.5 5.50001L6.5 5.50001M18.5 19.5L6.5 19.5L6.5 15.5L18.5 15.5L18.5 19.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "square"
    })
  }));
});
const InsertBelowIcon = forwardRef(function InsertBelowIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "insert-below",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.5 14.5H14.5M12.5 12.5V16.5M6.5 19.5H18.5M6.5 5.5H18.5V9.5H6.5V5.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "square"
    })
  }));
});
const ItalicIcon = forwardRef(function ItalicIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "italic",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.43 18H11.7276L13.4551 9.86763H12.1576L10.43 18ZM13.3043 8.29848C13.8022 8.29848 14.2095 7.89111 14.2095 7.39321C14.2095 6.89531 13.8022 6.48794 13.3043 6.48794C12.8064 6.48794 12.399 6.89531 12.399 7.39321C12.399 7.89111 12.8064 8.29848 13.3043 8.29848Z",
      fill: "currentColor"
    })
  }));
});
const JoystickIcon = forwardRef(function JoystickIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "joystick",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9.5 16V14.5H15.5V16M13.5 10.5V14.5M11.5 10.5V14.5M15.5 7.5C15.5 9.15685 14.1569 10.5 12.5 10.5C10.8431 10.5 9.5 9.15685 9.5 7.5C9.5 5.84315 10.8431 4.5 12.5 4.5C14.1569 4.5 15.5 5.84315 15.5 7.5ZM18.5 19.5H6.5C5.94772 19.5 5.5 19.0523 5.5 18.5V17.5C5.5 16.9477 5.94772 16.5 6.5 16.5H18.5C19.0523 16.5 19.5 16.9477 19.5 17.5V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const LaunchIcon = forwardRef(function LaunchIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "launch",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M14 6.5H5.5V19.5H18.5V11M20.5 4.5L10.5 14.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16 4.5H20.5V9",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const LeaveIcon = forwardRef(function LeaveIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "leave",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M16.5 15V19.5H5.5V5.5H16.5V10M10 12.5H22.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M20 10L22.5 12.5L20 15",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const LemonIcon = forwardRef(function LemonIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "lemon",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.6569 10.3431L6.41422 14.5858C7.58579 15.7574 9.12132 16.3431 10.6569 16.3431M10.6569 10.3431L14.8995 6.1005C16.0711 7.27208 16.6569 8.80761 16.6569 10.3431M10.6569 10.3431L10.6569 16.3431M10.6569 10.3431L16.6569 10.3431M10.6569 10.3431L14.8995 14.5858M14.8995 14.5858C13.7279 15.7574 12.1924 16.3431 10.6569 16.3431M14.8995 14.5858C16.0711 13.4142 16.6569 11.8787 16.6569 10.3431M16.3137 4.68629C19.4379 7.81049 19.4379 12.8758 16.3137 16C13.1895 19.1242 8.12419 19.1242 5 16L16.3137 4.68629Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const LinkIcon = forwardRef(function LinkIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "link",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M11 12.5L12.5 14C13.281 14.7811 14.719 14.7811 15.5 14L18.5 11C19.281 10.219 19.281 8.78105 18.5 8L18 7.50001C17.2189 6.71896 15.781 6.71896 15 7.5L13 9.5M12 15.5L10 17.5C9.21895 18.281 7.78105 18.281 7 17.5L6.5 17C5.71895 16.219 5.71896 14.7811 6.5 14L9.50001 11C10.2811 10.219 11.719 10.219 12.5 11L14 12.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const LinkRemovedIcon = forwardRef(function LinkRemovedIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "link-removed",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.4243 7.07574C17.9038 6.55531 17.1875 6.31422 16.5 6.31422C15.8125 6.31422 15.0962 6.55531 14.5757 7.07574L12.5757 9.07574L13.4243 9.92427L15.4243 7.92427C15.6849 7.66365 16.078 7.51422 16.5 7.51422C16.922 7.51422 17.3151 7.66365 17.5757 7.92427L17.9983 7.50165L17.5757 7.92427L18.0757 8.42427C18.3363 8.68488 18.4858 9.07799 18.4858 9.5C18.4858 9.92201 18.3363 10.3151 18.0757 10.5757L16.7515 11.9H18.4485L18.9243 11.4243C19.4447 10.9038 19.6858 10.1875 19.6858 9.5C19.6858 8.81253 19.4447 8.09617 18.9243 7.57574L18.5 8L18.9243 7.57574L18.4243 7.07574ZM12.0757 11.4243L12.5515 11.9H14.2485L12.9243 10.5757C12.4038 10.0553 11.6875 9.81421 11 9.81421C10.3125 9.81421 9.59617 10.0553 9.07574 10.5757L7.75147 11.9H9.44853L9.92427 11.4243C10.1849 11.1636 10.578 11.0142 11 11.0142C11.422 11.0142 11.8151 11.1636 12.0757 11.4243ZM7.24853 14.1H5.67654C5.43071 14.5303 5.31421 15.0221 5.31421 15.5C5.31421 16.1875 5.55529 16.9038 6.07573 17.4243L6.4965 17.0035L6.07573 17.4243L6.57573 17.9243C7.09616 18.4447 7.81252 18.6858 8.49999 18.6858C9.18746 18.6858 9.90382 18.4447 10.4243 17.9243L12.4243 15.9243L11.5757 15.0757L9.57573 17.0757C9.31511 17.3363 8.922 17.4858 8.49999 17.4858C8.07798 17.4858 7.68487 17.3363 7.42426 17.0757L6.99999 17.5L7.42425 17.0757L6.92426 16.5757C6.66364 16.3151 6.51421 15.922 6.51421 15.5C6.51421 15.078 6.66365 14.6849 6.92426 14.4243L7.24853 14.1ZM16.2485 14.1H11.7515L12.0757 14.4243C12.5962 14.9447 13.3125 15.1858 14 15.1858C14.6875 15.1858 15.4038 14.9447 15.9243 14.4243L16.2485 14.1ZM2 13.6H23V12.4H2V13.6Z",
      fill: "currentColor"
    })
  }));
});
const LockIcon = forwardRef(function LockIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "lock",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M15.5 11.5V8.5C15.5 6.5 14 5.5 12.5 5.5C11 5.5 9.5 6.5 9.5 8.5V11.5M7.5 11.5H17.5V19.5H7.5V11.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const LogoJsIcon = forwardRef(function LogoJsIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "logo-js",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 5H5V20H20V5ZM12.5254 16.1572C12.5254 17.4189 11.7742 18.1536 10.4792 18.1536C9.24243 18.1536 8.49121 17.4189 8.45801 16.2942V16.261H9.67407V16.2859C9.69897 16.7466 9.9729 17.0703 10.4626 17.0703C10.9939 17.0703 11.272 16.7507 11.272 16.1489V12.011H12.5254V16.1572ZM18.2893 16.2153C18.2893 17.4023 17.3679 18.1536 15.8738 18.1536C14.4419 18.1536 13.5371 17.4688 13.4666 16.4062L13.4624 16.3398H14.6702L14.6743 16.3813C14.72 16.8296 15.2056 17.1326 15.907 17.1326C16.5752 17.1326 17.0359 16.813 17.0359 16.3523V16.3481C17.0359 15.9539 16.7412 15.7339 15.9983 15.5803L15.3674 15.4517C14.1223 15.1985 13.5869 14.6174 13.5869 13.7085V13.7043C13.5869 12.592 14.5415 11.8574 15.8696 11.8574C17.2683 11.8574 18.0901 12.5962 18.1689 13.5964L18.1731 13.6504H16.9944L16.9861 13.6006C16.9155 13.1731 16.5005 12.8743 15.8696 12.8743C15.2512 12.8784 14.8403 13.1606 14.8403 13.6089V13.613C14.8403 14.0032 15.1309 14.2356 15.8364 14.3809L16.4714 14.5095C17.7373 14.771 18.2893 15.2773 18.2893 16.2112V16.2153Z",
      fill: "currentColor"
    })
  }));
});
const LogoTsIcon = forwardRef(function LogoTsIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "logo-ts",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 5H5V20H20V5ZM11.0769 18H9.82349V13.0444H8.02637V12.011H12.874V13.0444H11.0769V18ZM18.2893 16.2153C18.2893 17.4023 17.3679 18.1536 15.8738 18.1536C14.4419 18.1536 13.5371 17.4688 13.4666 16.4062L13.4624 16.3398H14.6702L14.6743 16.3813C14.72 16.8296 15.2056 17.1326 15.907 17.1326C16.5752 17.1326 17.0359 16.813 17.0359 16.3523V16.3481C17.0359 15.9539 16.7412 15.7339 15.9983 15.5803L15.3674 15.4517C14.1223 15.1985 13.5869 14.6174 13.5869 13.7085V13.7043C13.5869 12.592 14.5415 11.8574 15.8696 11.8574C17.2683 11.8574 18.0901 12.5962 18.1689 13.5964L18.1731 13.6504H16.9944L16.9861 13.6006C16.9155 13.1731 16.5005 12.8743 15.8696 12.8743C15.2512 12.8784 14.8403 13.1606 14.8403 13.6089V13.613C14.8403 14.0032 15.1309 14.2356 15.8364 14.3809L16.4714 14.5095C17.7373 14.771 18.2893 15.2773 18.2893 16.2112V16.2153Z",
      fill: "currentColor"
    })
  }));
});
const MasterDetailIcon = forwardRef(function MasterDetailIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "master-detail",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M6 8.5H9M10.5 5.5V19.5M6 11.5H9M13 8.5H18M6 14.5H9M4.5 5.5H20.5V19.5H4.5V5.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const MenuIcon = forwardRef(function MenuIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "menu",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M6 8.1H19V6.9H6V8.1ZM6 18.1H19V16.9H6V18.1ZM6 13.1H19V11.9H6V13.1Z",
      fill: "currentColor"
    })
  }));
});
const MobileDeviceIcon = forwardRef(function MobileDeviceIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "mobile-device",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8.1 6.5C8.1 5.7268 8.7268 5.1 9.5 5.1V3.9C8.06406 3.9 6.9 5.06406 6.9 6.5H8.1ZM8.1 18.5V6.5H6.9V18.5H8.1ZM9.5 19.9C8.7268 19.9 8.1 19.2732 8.1 18.5H6.9C6.9 19.9359 8.06406 21.1 9.5 21.1V19.9ZM15.5 19.9H9.5V21.1H15.5V19.9ZM16.9 18.5C16.9 19.2732 16.2732 19.9 15.5 19.9V21.1C16.9359 21.1 18.1 19.9359 18.1 18.5H16.9ZM16.9 6.5V18.5H18.1V6.5H16.9ZM15.5 5.1C16.2732 5.1 16.9 5.7268 16.9 6.5H18.1C18.1 5.06406 16.9359 3.9 15.5 3.9V5.1ZM9.5 5.1H15.5V3.9H9.5V5.1ZM12.9 17.5C12.9 17.7209 12.7209 17.9 12.5 17.9V19.1C13.3837 19.1 14.1 18.3837 14.1 17.5H12.9ZM12.5 17.1C12.7209 17.1 12.9 17.2791 12.9 17.5H14.1C14.1 16.6163 13.3837 15.9 12.5 15.9V17.1ZM12.1 17.5C12.1 17.2791 12.2791 17.1 12.5 17.1V15.9C11.6163 15.9 10.9 16.6163 10.9 17.5H12.1ZM12.5 17.9C12.2791 17.9 12.1 17.7209 12.1 17.5H10.9C10.9 18.3837 11.6163 19.1 12.5 19.1V17.9Z",
      fill: "currentColor"
    })
  }));
});
const MoonIcon = forwardRef(function MoonIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "moon",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M19.6065 16.1775C18.9417 16.387 18.234 16.5 17.5 16.5C13.634 16.5 10.5 13.366 10.5 9.5C10.5 7.54163 11.3042 5.77109 12.6004 4.50062C12.567 4.50021 12.5335 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C15.5924 20.5 18.275 18.7454 19.6065 16.1775Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const OkHandIcon = forwardRef(function OkHandIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "ok-hand",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M15.9957 11.5C14.8197 10.912 11.9957 9 10.4957 9C8.9957 9 5.17825 11.7674 6 13C7 14.5 9.15134 11.7256 10.4957 12C11.8401 12.2744 13 13.5 13 14.5C13 15.5 11.8401 16.939 10.4957 16.5C9.15134 16.061 8.58665 14.3415 7.4957 14C6.21272 13.5984 5.05843 14.6168 5.5 15.5C5.94157 16.3832 7.10688 17.6006 8.4957 19C9.74229 20.2561 11.9957 21.5 14.9957 20C17.9957 18.5 18.5 16.2498 18.5 13C18.5 11.5 13.7332 5.36875 11.9957 4.5C10.9957 4 10 5 10.9957 6.5C11.614 7.43149 13.5 9.27705 14 10.3751M15.5 8C15.5 8 15.3707 7.5 14.9957 6C14.4957 4 15.9957 3.5 16.4957 4.5C17.1281 5.76491 18.2872 10.9147 18.4957 13",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const OlistIcon = forwardRef(function OlistIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "olist",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M7.5 18.5V19H8.30902L7.94721 18.2764L7.5 18.5ZM7.5 16.5L7.94721 16.7236L8.30902 16H7.5V16.5ZM7 17.5L6.55279 17.2764L6.44098 17.5L6.55279 17.7236L7 17.5ZM6.5 6.5H7V6H6.5V6.5ZM6 13.5L5.55279 13.2764L5.19098 14H6V13.5ZM7 11.5L7.44721 11.7236L7.80902 11H7V11.5ZM10 8H19V7H10V8ZM10 13H19V12H10V13ZM10 18H19V17H10V18ZM5 19H7.5V18H5V19ZM7.5 16H5V17H7.5V16ZM7.94721 18.2764L7.44721 17.2764L6.55279 17.7236L7.05279 18.7236L7.94721 18.2764ZM7.44721 17.7236L7.94721 16.7236L7.05279 16.2764L6.55279 17.2764L7.44721 17.7236ZM5 7H6.5V6H5V7ZM5 9H6.5V8H5V9ZM6.5 9H8V8H6.5V9ZM6 6.5V8.5H7V6.5H6ZM8 13H6V14H8V13ZM6.44721 13.7236L7.44721 11.7236L6.55279 11.2764L5.55279 13.2764L6.44721 13.7236ZM7 11H5V12H7V11Z",
      fill: "currentColor"
    })
  }));
});
const OverageIcon = forwardRef(function OverageIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "overage",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 5.9H18.5H19.1V6.5V11H17.9V7.94853L12.8485 13H11.1515L17.0515 7.1H14V5.9ZM10.2515 13.9H11.9485H22V15.1L12.95 15.1H7.95L3 15.1V13.9H10.2515ZM8.15148 16L6.07574 18.0757L6.92426 18.9243L9.84853 16H8.15148Z",
      fill: "currentColor"
    })
  }));
});
const PackageIcon = forwardRef(function PackageIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "package",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 13V22M12.5 13L4.5 8M12.5 13L20.5 8M8.5 5.5L16.5 10.5M4.5 8L12.5 3L20.5 8V17L12.5 22L4.5 17V8Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const PauseIcon = forwardRef(function PauseIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "pause",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 7.5H8.5V17.5H10.5V7.5ZM16.5 7.5H14.5V17.5H16.5V7.5Z",
      fill: "currentColor"
    }), /* @__PURE__ */jsx("path", {
      d: "M8.5 7.5V6.9H7.9V7.5H8.5ZM10.5 7.5H11.1V6.9H10.5V7.5ZM8.5 17.5H7.9V18.1H8.5V17.5ZM10.5 17.5V18.1H11.1V17.5H10.5ZM14.5 7.5V6.9H13.9V7.5H14.5ZM16.5 7.5H17.1V6.9H16.5V7.5ZM14.5 17.5H13.9V18.1H14.5V17.5ZM16.5 17.5V18.1H17.1V17.5H16.5ZM8.5 8.1H10.5V6.9H8.5V8.1ZM9.1 17.5V7.5H7.9V17.5H9.1ZM10.5 16.9H8.5V18.1H10.5V16.9ZM9.9 7.5V17.5H11.1V7.5H9.9ZM14.5 8.1H16.5V6.9H14.5V8.1ZM15.1 17.5V7.5H13.9V17.5H15.1ZM16.5 16.9H14.5V18.1H16.5V16.9ZM15.9 7.5V17.5H17.1V7.5H15.9Z",
      fill: "currentColor"
    })]
  }));
});
const PinIcon = forwardRef(function PinIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "pin",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M6.5 10.5C6.5 7 9 4.5 12.5 4.5C16 4.5 18.5 7 18.5 10.5C18.5 14 15.5 17.5 12.5 20.5C9.5 17.5 6.5 14 6.5 10.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M14 10.5C14 11.3284 13.3284 12 12.5 12C11.6716 12 11 11.3284 11 10.5C11 9.67157 11.6716 9 12.5 9C13.3284 9 14 9.67157 14 10.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const PinRemovedIcon = forwardRef(function PinRemovedIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "pin-removed",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0757 20.9243L12.5 21.3485L12.9243 20.9243C14.4315 19.417 15.9655 17.7584 17.1242 16.0203C17.5402 15.3963 17.9127 14.7549 18.2192 14.1H16.8785C16.6575 14.5172 16.4051 14.9356 16.1258 15.3547C15.1381 16.8362 13.8436 18.2803 12.5 19.6478C11.1564 18.2803 9.86189 16.8362 8.87423 15.3547C8.59486 14.9356 8.34249 14.5172 8.12154 14.1H6.78084C7.08725 14.7549 7.45976 15.3963 7.87577 16.0203C9.03448 17.7584 10.5685 19.417 12.0757 20.9243ZM19.1 10.5C19.1 10.9701 19.0508 11.4372 18.9594 11.9H17.732C17.8418 11.4297 17.9 10.9627 17.9 10.5C17.9 7.33137 15.6686 5.1 12.5 5.1C9.33137 5.1 7.1 7.33137 7.1 10.5C7.1 10.9627 7.15822 11.4297 7.26799 11.9H6.04056C5.94923 11.4372 5.9 10.9701 5.9 10.5C5.9 6.66863 8.66863 3.9 12.5 3.9C16.3314 3.9 19.1 6.66863 19.1 10.5ZM14.6 10.5C14.6 11.0379 14.3978 11.5285 14.0653 11.9H10.9347C10.6022 11.5285 10.4 11.0379 10.4 10.5C10.4 9.3402 11.3402 8.4 12.5 8.4C13.6598 8.4 14.6 9.3402 14.6 10.5ZM11.6 10.5C11.6 10.0029 12.0029 9.6 12.5 9.6C12.9971 9.6 13.4 10.0029 13.4 10.5C13.4 10.9971 12.9971 11.4 12.5 11.4C12.0029 11.4 11.6 10.9971 11.6 10.5ZM2 13.6H23V12.4H2V13.6Z",
      fill: "currentColor"
    })
  }));
});
const PlayIcon = forwardRef(function PlayIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "play",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M7.5 18.5V6.5L17.5 12.5L7.5 18.5Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const PlugIcon = forwardRef(function PlugIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "plug",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M13.25 8.5L16.75 5M16.25 11.5L19.75 8M9.25 15.5L5.25 19.5M7.75 14L9.75 12C8.25 10 8.75 9 9.75 8C10.15 7.6 11.25 6.5 11.25 6.5L18.25 13.5C18.25 13.5 17.3825 14.3675 16.75 15C15.75 16 14.75 16.5 12.75 15L10.75 17L7.75 14Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const PresentationIcon = forwardRef(function PresentationIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "presentation",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.5 18H5.5V8.5H19.5V18H14.5M10.5 18L9 22M10.5 18H14.5M14.5 18L16 22M4.5 8.5H20.5V6.5H4.5V8.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const PublishIcon = forwardRef(function PublishIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "publish",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M4.99997 5.50005H20M7.5 14L12.5 9.00003L17.5 14",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M12.5 9.00003V20",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const ReadOnlyIcon = forwardRef(function ReadOnlyIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "read-only",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M15 7L18 10M10 12L7 15L6 19L10 18L13 15M12 10L17 5L20 8L15 13M19 19L5 5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const RemoveCircleIcon = forwardRef(function RemoveCircleIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "remove-circle",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 12.4H17M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const RemoveIcon = forwardRef(function RemoveIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "remove",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5 12.5H20",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ResetIcon = forwardRef(function ResetIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "reset",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M4.56189 13.5L4.14285 13.9294L4.5724 14.3486L4.99144 13.9189L4.56189 13.5ZM9.92427 15.9243L15.9243 9.92427L15.0757 9.07574L9.07574 15.0757L9.92427 15.9243ZM9.07574 9.92426L15.0757 15.9243L15.9243 15.0757L9.92426 9.07574L9.07574 9.92426ZM19.9 12.5C19.9 16.5869 16.5869 19.9 12.5 19.9V21.1C17.2496 21.1 21.1 17.2496 21.1 12.5H19.9ZM5.1 12.5C5.1 8.41309 8.41309 5.1 12.5 5.1V3.9C7.75035 3.9 3.9 7.75035 3.9 12.5H5.1ZM12.5 5.1C16.5869 5.1 19.9 8.41309 19.9 12.5H21.1C21.1 7.75035 17.2496 3.9 12.5 3.9V5.1ZM5.15728 13.4258C5.1195 13.1227 5.1 12.8138 5.1 12.5H3.9C3.9 12.8635 3.92259 13.2221 3.9665 13.5742L5.15728 13.4258ZM12.5 19.9C9.9571 19.9 7.71347 18.6179 6.38048 16.6621L5.38888 17.3379C6.93584 19.6076 9.54355 21.1 12.5 21.1V19.9ZM4.99144 13.9189L7.42955 11.4189L6.57045 10.5811L4.13235 13.0811L4.99144 13.9189ZM4.98094 13.0706L2.41905 10.5706L1.58095 11.4294L4.14285 13.9294L4.98094 13.0706Z",
      fill: "currentColor"
    })
  }));
});
const RestoreIcon = forwardRef(function RestoreIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "restore",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M5.88468 17C7.32466 19.1128 9.75033 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5V13.5M12.5 8V12.5L15.5 15.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M7 11L4.5 13.5L2 11",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const RetrieveIcon = forwardRef(function RetrieveIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "retrieve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M12.5 10.5L12.5 17.5M4.5 7.5V20.5H20.5V7.5L18.5 4.5H6.5L4.5 7.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M9 14L12.5 10.5L16 14",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M4.5 7.5H20.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const RevertIcon = forwardRef(function RevertIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "revert",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M5 9L14.5 9C16.9853 9 19 11.0147 19 13.5C19 15.9853 16.9853 18 14.5 18H5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M9 13L5 9L9 5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const RobotIcon = forwardRef(function RobotIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "robot",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 15.5V17.5M12.5 8.5V6.5M12.5 6.5C13.3284 6.5 14 5.82843 14 5C14 4.17157 13.3284 3.5 12.5 3.5C11.6716 3.5 11 4.17157 11 5C11 5.82843 11.6716 6.5 12.5 6.5ZM20.5 20.5V19.5C20.5 18.3954 19.6046 17.5 18.5 17.5H6.5C5.39543 17.5 4.5 18.3954 4.5 19.5V20.5H20.5ZM11.5 12C11.5 12.5523 11.0523 13 10.5 13C9.94772 13 9.5 12.5523 9.5 12C9.5 11.4477 9.94772 11 10.5 11C11.0523 11 11.5 11.4477 11.5 12ZM15.5 12C15.5 12.5523 15.0523 13 14.5 13C13.9477 13 13.5 12.5523 13.5 12C13.5 11.4477 13.9477 11 14.5 11C15.0523 11 15.5 11.4477 15.5 12ZM8.5 15.5H16.5C17.6046 15.5 18.5 14.6046 18.5 13.5V10.5C18.5 9.39543 17.6046 8.5 16.5 8.5H8.5C7.39543 8.5 6.5 9.39543 6.5 10.5V13.5C6.5 14.6046 7.39543 15.5 8.5 15.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const RocketIcon = forwardRef(function RocketIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "rocket",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 20.5L15.5 14M11 9.5L4.5 12.5M9 14C9 14 7.54688 14.9531 6.5 16C5.5 17 4.5 20.5 4.5 20.5C4.5 20.5 8 19.5 9 18.5C10 17.5 11 16 11 16M9 14C9 14 10.1 9.90001 12.5 7.50001C15.5 4.50001 20.5 4.50001 20.5 4.50001C20.5 4.50001 20.5 9.5 17.5 12.5C15.7492 14.2508 11 16 11 16L9 14ZM16.5 10C16.5 10.8284 15.8284 11.5 15 11.5C14.1716 11.5 13.5 10.8284 13.5 10C13.5 9.17157 14.1716 8.5 15 8.5C15.8284 8.5 16.5 9.17157 16.5 10Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SearchIcon = forwardRef(function SearchIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "search",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M14.0355 14.0355L20 20M15.5 10.5C15.5 13.2614 13.2614 15.5 10.5 15.5C7.73858 15.5 5.5 13.2614 5.5 10.5C5.5 7.73858 7.73858 5.5 10.5 5.5C13.2614 5.5 15.5 7.73858 15.5 10.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SelectIcon = forwardRef(function SelectIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "select",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M16.5 15.5L12.5 19.5L8.5 15.5M8.5 9.5L12.5 5.5L16.5 9.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SortIcon = forwardRef(function SortIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "sort",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8.5 18.5V6M16.5 19V6.5M12 15L8.5 18.5L5 15M13 10L16.5 6.5L20 10",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SpinnerIcon = forwardRef(function SpinnerIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "spinner",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SplitHorizontalIcon = forwardRef(function SplitHorizontalIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "split-horizontal",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M19.5 10.5V20.5H5.5V10.5M19.5 10.5H5.5M19.5 10.5V4.5H5.5V10.5M12.5 13V15.5M12.5 18V15.5M12.5 15.5H15M12.5 15.5H10",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SplitVerticalIcon = forwardRef(function SplitVerticalIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "split-vertical",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10.5 5.5V19.5M13 12.5H15.5M18 12.5H15.5M15.5 12.5V15M15.5 12.5V10M4.5 5.5H20.5V19.5H4.5V5.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SquareIcon = forwardRef(function SquareIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "square",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("rect", {
      x: 5.5,
      y: 5.5,
      width: 14,
      height: 14,
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const StackCompactIcon = forwardRef(function StackCompactIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "stack-compact",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 15.5V18.5H19.5V15.5M5.5 15.5H19.5M5.5 15.5V9.5M19.5 15.5V9.5M5.5 9.5V6.5H19.5V9.5M5.5 9.5H19.5M5.5 12.5H19.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const StackIcon = forwardRef(function StackIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "stack",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5.5 12.5H19.5M5.5 18.5H19.5V6.5H5.5V18.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const StarIcon = forwardRef(function StarIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "star",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M13 4L15.2747 9.8691L21.5595 10.2188L16.6806 14.1959L18.2901 20.2812L13 16.87L7.70993 20.2812L9.31941 14.1959L4.44049 10.2188L10.7253 9.8691L13 4Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const StopIcon = forwardRef(function StopIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "stop",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("rect", {
      x: 7.5,
      y: 7.5,
      width: 10,
      height: 10,
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const StrikethroughIcon = forwardRef(function StrikethroughIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "strikethrough",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5656 7.73438C11.0656 7.73438 10.0734 8.48438 10.0734 9.625C10.0734 10.2317 10.3649 10.6613 11.0519 11H8.90358C8.71703 10.6199 8.62813 10.1801 8.62813 9.67188C8.62813 7.75781 10.2297 6.46094 12.6125 6.46094C14.7922 6.46094 16.4172 7.75781 16.5344 9.57812H15.1203C14.925 8.42188 13.9719 7.73438 12.5656 7.73438ZM12.4875 18.2656C10.0969 18.2656 8.44844 17 8.3 15.0547H9.72188C9.89375 16.2344 11.0188 16.9844 12.6203 16.9844C14.1359 16.9844 15.2531 16.1641 15.2531 15.0469C15.2531 14.6375 15.1255 14.292 14.8589 14H16.5912C16.6638 14.266 16.6984 14.5566 16.6984 14.875C16.6984 16.9453 15.0656 18.2656 12.4875 18.2656ZM7 13.1H18V11.9H7V13.1Z",
      fill: "currentColor"
    })
  }));
});
const SunIcon = forwardRef(function SunIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "sun",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M19 12.5H22M3 12.5H6M12.5 6V3M12.5 22V19M17.3891 7.61091L19.5104 5.48959M5.48959 19.5104L7.61091 17.3891M7.61091 7.61091L5.48959 5.48959M19.5104 19.5104L17.3891 17.3891M16 12.5C16 14.433 14.433 16 12.5 16C10.567 16 9 14.433 9 12.5C9 10.567 10.567 9 12.5 9C14.433 9 16 10.567 16 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const SyncIcon = forwardRef(function SyncIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "sync",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M13.5 4.5H12.5C8.08172 4.5 4.5 8.08172 4.5 12.5C4.5 15.6631 6.33576 18.3975 9 19.6958M11.5 20.5H12.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 9.33688 18.6642 6.60253 16 5.30423",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M14 17.5619L11.5 20.5L14.5 23.0619M11 7.43811L13.5 4.50001L10.5 1.93811",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const TagIcon = forwardRef(function TagIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "tag",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M12.5 20L5 20L5 12.5L12.5 5L20 12.5L12.5 20Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M11 15.5C11 16.3284 10.3284 17 9.5 17C8.67157 17 8 16.3284 8 15.5C8 14.6716 8.67157 14 9.5 14C10.3284 14 11 14.6716 11 15.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const TerminalIcon = forwardRef(function TerminalIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "terminal",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8.5 9.5L11.5 12.5L8.5 15.5M13 15.5H17M5.5 6.5H19.5V18.5H5.5V6.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ThLargeIcon = forwardRef(function ThLargeIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "th-large",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 6.5V12.5M12.5 12.5V18.5M12.5 12.5H20.5M12.5 12.5H4.5M4.5 6.5H20.5V18.5H4.5V6.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const ThListIcon = forwardRef(function ThListIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "th-list",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M9.5 6.5V10.5M9.5 10.5V14.5M9.5 10.5H20.5M9.5 10.5H4.5M9.5 14.5V18.5M9.5 14.5H20.5M9.5 14.5H4.5M4.5 6.5H20.5V18.5H4.5V6.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const TiersIcon = forwardRef(function TiersIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "tiers",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M16.5 14.5L20.5 16.5L12.5 20.5L4.5 16.5L8.5 14.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16.5 10.5L20.5 12.5L12.5 16.5L4.5 12.5L8.5 10.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M20.5 8.5L12.5 12.5L4.5 8.5L12.5 4.5L20.5 8.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const ToggleArrowRightIcon = forwardRef(function ToggleArrowRightIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "toggle-arrow-right",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10 16.5V8.5L16 12.5L10 16.5Z",
      fill: "currentColor"
    })
  }));
});
const TokenIcon = forwardRef(function TokenIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "token",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17.5711 12.5C17.5711 15.2614 15.3325 17.5 12.5711 17.5M7.57107 12.5C7.57107 9.73858 9.80964 7.5 12.5711 7.5M20.5 12.5C20.5 16.9183 16.9183 20.5 12.5 20.5C8.08172 20.5 4.5 16.9183 4.5 12.5C4.5 8.08172 8.08172 4.5 12.5 4.5C16.9183 4.5 20.5 8.08172 20.5 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const TransferIcon = forwardRef(function TransferIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "transfer",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M19.5 16.5H6M5.5 8.5L19 8.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M16 13L19.5 16.5L16 20M9 12L5.5 8.5L9 5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const TranslateIcon = forwardRef(function TranslateIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "translate",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.4 5.4H4V6.6H13.2189C13.1612 6.78478 13.0895 6.99578 13.0025 7.22211C12.7032 8.00031 12.2402 8.91125 11.5757 9.57574L10 11.1515L9.42426 10.5757C8.72102 9.8725 8.25297 9.16987 7.96199 8.64611C7.81668 8.38455 7.71617 8.16874 7.65305 8.02146C7.62151 7.94787 7.59937 7.89154 7.5857 7.85534C7.57886 7.83725 7.57415 7.8242 7.57144 7.81657L7.56886 7.80922C7.56886 7.80922 7.56921 7.81026 7 8C6.43079 8.18974 6.43091 8.19009 6.43091 8.19009L6.43133 8.19135L6.43206 8.19351L6.4341 8.19948L6.44052 8.21786C6.44587 8.23292 6.45336 8.25357 6.46313 8.27942C6.48266 8.33112 6.5113 8.40369 6.55008 8.49416C6.62758 8.67501 6.74582 8.92795 6.91301 9.22889C7.24703 9.83013 7.77898 10.6275 8.57574 11.4243L9.15147 12L4.57964 16.5718L4.57655 16.5749L4.57577 16.5757L5.4243 17.4242L5.42688 17.4216L10.0368 12.8117L12.6159 14.9609L13.3841 14.0391L10.8888 11.9597L12.4243 10.4243C13.2598 9.58875 13.7968 8.49969 14.1225 7.65289C14.2818 7.23863 14.395 6.87072 14.4696 6.6H16V5.4H10.6V4H9.4V5.4ZM17.4405 10L21.553 19.7672H20.2509L19.1279 17.1H14.8721L13.7491 19.7672H12.447L16.5595 10H17.4405ZM15.3773 15.9H18.6227L17 12.0462L15.3773 15.9Z",
      fill: "currentColor"
    })
  }));
});
const TrashIcon = forwardRef(function TrashIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "trash",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5 6.5H20M10 6.5V4.5C10 3.94772 10.4477 3.5 11 3.5H14C14.5523 3.5 15 3.94772 15 4.5V6.5M12.5 9V17M15.5 9L15 17M9.5 9L10 17M18.5 6.5L17.571 18.5767C17.5309 19.0977 17.0965 19.5 16.574 19.5H8.42603C7.90349 19.5 7.46905 19.0977 7.42898 18.5767L6.5 6.5H18.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const TrendUpwardIcon = forwardRef(function TrendUpwardIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "trend-upward",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M4.5 18.5L11.5 10.5L13.5 14.5L20.5 6.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M20.5 11V6.5H16",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const TriangleOutlineIcon = forwardRef(function TriangleOutlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "triangle-outline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M20.5 18.5H4.5L12.5 5.5L20.5 18.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const TrolleyIcon = forwardRef(function TrolleyIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "trolley",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 17.5L5.81763 6.26772C5.71013 5.81757 5.30779 5.5 4.84498 5.5H3M8 17.5H17M8 17.5C8.82843 17.5 9.5 18.1716 9.5 19C9.5 19.8284 8.82843 20.5 8 20.5C7.17157 20.5 6.5 19.8284 6.5 19C6.5 18.1716 7.17157 17.5 8 17.5ZM17 17.5C17.8284 17.5 18.5 18.1716 18.5 19C18.5 19.8284 17.8284 20.5 17 20.5C16.1716 20.5 15.5 19.8284 15.5 19C15.5 18.1716 16.1716 17.5 17 17.5ZM7.78357 14.5H17.5L19 7.5H6",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const TruncateIcon = forwardRef(function TruncateIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "truncate",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M5 12.5H20M8.5 19.5L12.5 15.5L16.5 19.5M16.5 5.5L12.5 9.5L8.5 5.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const UlistIcon = forwardRef(function UlistIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "ulist",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M10 7.5H19M10 17.5H19M10 12.5H19M7.10153 17.5001C7.10153 17.8323 6.83221 18.1016 6.5 18.1016C6.16778 18.1016 5.89847 17.8323 5.89847 17.5001C5.89847 17.1678 6.16778 16.8985 6.5 16.8985C6.83221 16.8985 7.10153 17.1678 7.10153 17.5001ZM7.10153 7.5C7.10153 7.83221 6.83221 8.10153 6.5 8.10153C6.16778 8.10153 5.89847 7.83221 5.89847 7.5C5.89847 7.16778 6.16778 6.89847 6.5 6.89847C6.83221 6.89847 7.10153 7.16778 7.10153 7.5ZM7.10153 12.5C7.10153 12.8322 6.83221 13.1015 6.5 13.1015C6.16778 13.1015 5.89847 12.8322 5.89847 12.5C5.89847 12.1678 6.16778 11.8985 6.5 11.8985C6.83221 11.8985 7.10153 12.1678 7.10153 12.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const UnderlineIcon = forwardRef(function UnderlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "underline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.17 7.11409H9.52791V14.1677C9.52791 15.8123 10.6067 17.0042 12.4927 17.0042C14.3787 17.0042 15.4574 15.8123 15.4574 14.1677V7.11409H16.8154V14.2582C16.8154 16.5817 15.1934 18.2565 12.4927 18.2565C9.79195 18.2565 8.17 16.5817 8.17 14.2582V7.11409ZM7 21.1H18V19.9H7V21.1Z",
      fill: "currentColor"
    })
  }));
});
const UndoIcon = forwardRef(function UndoIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "undo",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M5.88468 17C7.32466 19.1128 9.75033 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5V13.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M7 11L4.5 13.5L2 11",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const UnknownIcon = forwardRef(function UnknownIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "unknown",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 13C12.5 11 14 11.5 14 10C14 9.34375 13.5 8.5 12.5 8.5C11.5 8.5 11 9 10.5 9.5M12.5 16V14.5M5.5 5.5H19.5V19.5H5.5V5.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const UnlockIcon = forwardRef(function UnlockIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "unlock",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M7.5 11.5H17.5V19.5H7.5V11.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M3.5 11.5V8.5C3.5 6.5 5 5.5 6.5 5.5C8 5.5 9.5 6.5 9.5 8.5V11.5",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const UnpublishIcon = forwardRef(function UnpublishIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "unpublish",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M5 19.5H20M12.5 16V4.99998",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M17.5 11L12.5 16L7.5 11",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const UploadIcon = forwardRef(function UploadIcon2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "upload",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M12.5 6.00003V15.5M5.5 15.5H19.5V19.5H5.5V15.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    }), /* @__PURE__ */jsx("path", {
      d: "M7.5 11L12.5 6.00003L17.5 11",
      stroke: "currentColor",
      strokeWidth: 1.2
    })]
  }));
});
const UserIcon = forwardRef(function UserIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "user",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M8 14.5C7 15 5.5 16 5.5 19.5H19.5C19.5 16 18.3416 15.1708 17 14.5C16 14 14 14 14 12.5C14 11 15 10.25 15 8.25C15 6.25 14 5.25 12.5 5.25C11 5.25 10 6.25 10 8.25C10 10.25 11 11 11 12.5C11 14 9 14 8 14.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const UsersIcon = forwardRef(function UsersIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "users",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M17.5 18.5H21.5C21.5 15 20.8416 14.1708 19.5 13.5C18.5 13 16.5 12.5 16.5 11C16.5 9.5 17.5 9 17.5 7C17.5 5 16.5 4 15 4C13.6628 4 12.723 4.79472 12.5347 6.38415M4.5 20.5C4.5 17 5.5 16 6.5 15.5C7.5 15 9.5 14.5 9.5 13C9.5 11.5 8.5 11 8.5 9C8.5 7 9.5 6 11 6C12.5 6 13.5 7 13.5 9C13.5 11 12.5 11.5 12.5 13C12.5 14.5 14.5 15 15.5 15.5C16.8416 16.1708 17.5 17 17.5 20.5H4.5Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const WarningFilledIcon = forwardRef(function WarningFilledIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "warning-filled",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7728 5.35558C13.7822 3.57248 11.2178 3.57247 10.2272 5.35558L3.62622 17.2373C2.66345 18.9703 3.91657 21.1 5.89903 21.1H19.101C21.0834 21.1 22.3365 18.9703 21.3738 17.2373L14.7728 5.35558ZM13 16V17.5H12V16H13ZM12 10.4999V14.5H13V10.4999H12Z",
      fill: "currentColor"
    })
  }));
});
const WarningOutlineIcon = forwardRef(function WarningOutlineIcon2(props, ref) {
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    "data-sanity-icon": "warning-outline",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M12.5 10V14M12.5 17V15.5M14.2483 5.64697L20.8493 17.5287C21.5899 18.8618 20.6259 20.5 19.101 20.5H5.89903C4.37406 20.5 3.41013 18.8618 4.15072 17.5287L10.7517 5.64697C11.5137 4.27535 13.4863 4.27535 14.2483 5.64697Z",
      stroke: "currentColor",
      strokeWidth: 1.2
    })
  }));
});
const icons = {
  "access-denied": AccessDeniedIcon,
  activity: ActivityIcon,
  "add-circle": AddCircleIcon,
  add: AddIcon,
  api: ApiIcon,
  archive: ArchiveIcon,
  "arrow-down": ArrowDownIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-top-right": ArrowTopRightIcon,
  "arrow-up": ArrowUpIcon,
  "bar-chart": BarChartIcon,
  basket: BasketIcon,
  bell: BellIcon,
  bill: BillIcon,
  "binary-document": BinaryDocumentIcon,
  "block-element": BlockElementIcon,
  blockquote: BlockquoteIcon,
  bold: BoldIcon,
  book: BookIcon,
  bottle: BottleIcon,
  "bulb-filled": BulbFilledIcon,
  "bulb-outline": BulbOutlineIcon,
  calendar: CalendarIcon,
  case: CaseIcon,
  "chart-upward": ChartUpwardIcon,
  "checkmark-circle": CheckmarkCircleIcon,
  checkmark: CheckmarkIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  circle: CircleIcon,
  clipboard: ClipboardIcon,
  "clipboard-image": ClipboardImageIcon,
  clock: ClockIcon,
  "close-circle": CloseCircleIcon,
  close: CloseIcon,
  "code-block": CodeBlockIcon,
  code: CodeIcon,
  cog: CogIcon,
  collapse: CollapseIcon,
  comment: CommentIcon,
  component: ComponentIcon,
  compose: ComposeIcon,
  controls: ControlsIcon,
  copy: CopyIcon,
  "credit-card": CreditCardIcon,
  crop: CropIcon,
  dashboard: DashboardIcon,
  database: DatabaseIcon,
  desktop: DesktopIcon,
  document: DocumentIcon,
  "document-pdf": DocumentPdfIcon,
  "document-remove": DocumentRemoveIcon,
  "document-sheet": DocumentSheetIcon,
  "document-text": DocumentTextIcon,
  "document-video": DocumentVideoIcon,
  "document-word": DocumentWordIcon,
  "document-zip": DocumentZipIcon,
  documents: DocumentsIcon,
  dot: DotIcon,
  "double-chevron-down": DoubleChevronDownIcon,
  "double-chevron-left": DoubleChevronLeftIcon,
  "double-chevron-right": DoubleChevronRightIcon,
  "double-chevron-up": DoubleChevronUpIcon,
  download: DownloadIcon,
  "drag-handle": DragHandleIcon,
  drop: DropIcon,
  "earth-americas": EarthAmericasIcon,
  "earth-globe": EarthGlobeIcon,
  edit: EditIcon,
  "ellipsis-horizontal": EllipsisHorizontalIcon,
  "ellipsis-vertical": EllipsisVerticalIcon,
  envelope: EnvelopeIcon,
  equal: EqualIcon,
  "error-filled": ErrorFilledIcon,
  "error-outline": ErrorOutlineIcon,
  expand: ExpandIcon,
  "eye-closed": EyeClosedIcon,
  "eye-open": EyeOpenIcon,
  filter: FilterIcon,
  folder: FolderIcon,
  generate: GenerateIcon,
  "heart-filled": HeartFilledIcon,
  heart: HeartIcon,
  "help-circle": HelpCircleIcon,
  home: HomeIcon,
  "ice-cream": IceCreamIcon,
  image: ImageIcon,
  "image-remove": ImageRemoveIcon,
  images: ImagesIcon,
  "info-filled": InfoFilledIcon,
  "info-outline": InfoOutlineIcon,
  "inline-element": InlineElementIcon,
  inline: InlineIcon,
  "insert-above": InsertAboveIcon,
  "insert-below": InsertBelowIcon,
  italic: ItalicIcon,
  joystick: JoystickIcon,
  launch: LaunchIcon,
  leave: LeaveIcon,
  lemon: LemonIcon,
  link: LinkIcon,
  "link-removed": LinkRemovedIcon,
  lock: LockIcon,
  "logo-js": LogoJsIcon,
  "logo-ts": LogoTsIcon,
  "master-detail": MasterDetailIcon,
  menu: MenuIcon,
  "mobile-device": MobileDeviceIcon,
  moon: MoonIcon,
  "ok-hand": OkHandIcon,
  olist: OlistIcon,
  overage: OverageIcon,
  package: PackageIcon,
  pause: PauseIcon,
  pin: PinIcon,
  "pin-removed": PinRemovedIcon,
  play: PlayIcon,
  plug: PlugIcon,
  presentation: PresentationIcon,
  publish: PublishIcon,
  "read-only": ReadOnlyIcon,
  "remove-circle": RemoveCircleIcon,
  remove: RemoveIcon,
  reset: ResetIcon,
  restore: RestoreIcon,
  retrieve: RetrieveIcon,
  revert: RevertIcon,
  robot: RobotIcon,
  rocket: RocketIcon,
  search: SearchIcon,
  select: SelectIcon,
  sort: SortIcon,
  spinner: SpinnerIcon,
  "split-horizontal": SplitHorizontalIcon,
  "split-vertical": SplitVerticalIcon,
  square: SquareIcon,
  "stack-compact": StackCompactIcon,
  stack: StackIcon,
  star: StarIcon,
  stop: StopIcon,
  strikethrough: StrikethroughIcon,
  sun: SunIcon,
  sync: SyncIcon,
  tag: TagIcon,
  terminal: TerminalIcon,
  "th-large": ThLargeIcon,
  "th-list": ThListIcon,
  tiers: TiersIcon,
  "toggle-arrow-right": ToggleArrowRightIcon,
  token: TokenIcon,
  transfer: TransferIcon,
  translate: TranslateIcon,
  trash: TrashIcon,
  "trend-upward": TrendUpwardIcon,
  "triangle-outline": TriangleOutlineIcon,
  trolley: TrolleyIcon,
  truncate: TruncateIcon,
  ulist: UlistIcon,
  underline: UnderlineIcon,
  undo: UndoIcon,
  unknown: UnknownIcon,
  unlock: UnlockIcon,
  unpublish: UnpublishIcon,
  upload: UploadIcon,
  user: UserIcon,
  users: UsersIcon,
  "warning-filled": WarningFilledIcon,
  "warning-outline": WarningOutlineIcon
};
const Icon = forwardRef(function Icon2(props, ref) {
  const {
      symbol
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const iconComponent = icons[symbol];
  if (!iconComponent) {
    return null;
  }
  return createElement(iconComponent, _objectSpread(_objectSpread({}, restProps), {}, {
    ref
  }));
});
export { AccessDeniedIcon, ActivityIcon, AddCircleIcon, AddIcon, ApiIcon, ArchiveIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowTopRightIcon, ArrowUpIcon, BarChartIcon, BasketIcon, BellIcon, BillIcon, BinaryDocumentIcon, BlockElementIcon, BlockquoteIcon, BoldIcon, BookIcon, BottleIcon, BulbFilledIcon, BulbOutlineIcon, CalendarIcon, CaseIcon, ChartUpwardIcon, CheckmarkCircleIcon, CheckmarkIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, CircleIcon, ClipboardIcon, ClipboardImageIcon, ClockIcon, CloseCircleIcon, CloseIcon, CodeBlockIcon, CodeIcon, CogIcon, CollapseIcon, CommentIcon, ComponentIcon, ComposeIcon, ControlsIcon, CopyIcon, CreditCardIcon, CropIcon, DashboardIcon, DatabaseIcon, DesktopIcon, DocumentIcon, DocumentPdfIcon, DocumentRemoveIcon, DocumentSheetIcon, DocumentTextIcon, DocumentVideoIcon, DocumentWordIcon, DocumentZipIcon, DocumentsIcon, DotIcon, DoubleChevronDownIcon, DoubleChevronLeftIcon, DoubleChevronRightIcon, DoubleChevronUpIcon, DownloadIcon, DragHandleIcon, DropIcon, EarthAmericasIcon, EarthGlobeIcon, EditIcon, EllipsisHorizontalIcon, EllipsisVerticalIcon, EnvelopeIcon, EqualIcon, ErrorFilledIcon, ErrorOutlineIcon, ExpandIcon, EyeClosedIcon, EyeOpenIcon, FilterIcon, FolderIcon, GenerateIcon, HeartFilledIcon, HeartIcon, HelpCircleIcon, HomeIcon, IceCreamIcon, Icon, ImageIcon, ImageRemoveIcon, ImagesIcon, InfoFilledIcon, InfoOutlineIcon, InlineElementIcon, InlineIcon, InsertAboveIcon, InsertBelowIcon, ItalicIcon, JoystickIcon, LaunchIcon, LeaveIcon, LemonIcon, LinkIcon, LinkRemovedIcon, LockIcon, LogoJsIcon, LogoTsIcon, MasterDetailIcon, MenuIcon, MobileDeviceIcon, MoonIcon, OkHandIcon, OlistIcon, OverageIcon, PackageIcon, PauseIcon, PinIcon, PinRemovedIcon, PlayIcon, PlugIcon, PresentationIcon, PublishIcon, ReadOnlyIcon, RemoveCircleIcon, RemoveIcon, ResetIcon, RestoreIcon, RetrieveIcon, RevertIcon, RobotIcon, RocketIcon, SearchIcon, SelectIcon, SortIcon, SpinnerIcon, SplitHorizontalIcon, SplitVerticalIcon, SquareIcon, StackCompactIcon, StackIcon, StarIcon, StopIcon, StrikethroughIcon, SunIcon, SyncIcon, TagIcon, TerminalIcon, ThLargeIcon, ThListIcon, TiersIcon, ToggleArrowRightIcon, TokenIcon, TransferIcon, TranslateIcon, TrashIcon, TrendUpwardIcon, TriangleOutlineIcon, TrolleyIcon, TruncateIcon, UlistIcon, UnderlineIcon, UndoIcon, UnknownIcon, UnlockIcon, UnpublishIcon, UploadIcon, UserIcon, UsersIcon, WarningFilledIcon, WarningOutlineIcon, icons };
//# sourceMappingURL=index.esm.js.map
